import { useState, useContext, useEffect } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../../../context/useAuth";
import { UserPreferenceContext } from "../../../context/UserPreferenceContext";
import { usePreference } from "../../../context/usePreference";
import { useTranslation } from "react-i18next";
import "./Home.css";
import blurPanel from "../../../utils/BlurPanel";
import { setUserPreferenceLocalStorage, getSelectTypeGridStorage } from "../../../context/utils";
import { UiContext } from "../../../context/UiContext";

import {
  SelectGridAux,
  changeSelectDivAux,
  controlNavBarAux,
  getClassSelecGraphButton,
  getClassSelecGrid,
  getTypeGrid,
  renderDivAnalytic,
  renderDivMedComp,
  renderDivMinuteChart,
  renderDivTelaMedia,
  validUserInstance,
  getSelectedTypeGrid,
} from "./HomeUtils";
import Loading from '../../components/Loading';
import PageRender from '../../components/PageRender';
import { ChannelsContext } from "../../../context/ChannelsContext";

function getInitialScreenValues() {
  const savedSelectTypeGrid = getSelectTypeGridStorage();
  
  if (savedSelectTypeGrid !== undefined && !isNaN(savedSelectTypeGrid)) {
    return getSelectedTypeGrid(savedSelectTypeGrid);
  }
  
  return { DivChart: 0, DivMinute: 0 };
}

function Home() {
  const auth = useAuth();
  const { doUserPreference, userAuthenticated } = useContext(
    UserPreferenceContext
  );
  const { channels } = useContext(ChannelsContext);
  const { t } = useTranslation();
  const [changePageToChangePassword, setChangePageToChangePassword] = useState<boolean>(false);
  const [sidebar, setSidebar] = useState<string>("");

  const [DivChart, setDivChart] = useState<number>(0);
  const [DivMinute, setDivMinute] = useState<number>(0);
  const [countryID, setCountryID] = useState<number>(1);
  const [isInitialized, setIsInitialized] = useState<boolean>(false);
  
  const { isMobile } = useContext(UiContext);
  const user = usePreference();
  
  useEffect(() => {
    if (user?.userPreference && user?.loaded) {
      const initialValues = getInitialScreenValues();
      setDivChart(initialValues.DivChart);
      setDivMinute(initialValues.DivMinute);
      
      setIsInitialized(true);
    }
  }, [user?.userPreference, user?.loaded]);

  if (userAuthenticated === false) return <Navigate to="/" />;
  if (changePageToChangePassword === true) {
    return <Navigate to="/changepassword" />;
  }
  if (user?.userPreference?.CodigoRetorno === 11) {
    const alreadyRedirected = localStorage.getItem('passwordChangeRedirected') ?? 'false';

    if (alreadyRedirected !== 'true') {
      return <Navigate to="/changepassword" />;
    }
  }

  if (user.userPreference == null) {
    return <Loading show={true} isMobile={isMobile} />;
  }

  if (validUserInstance(user, auth)) {
    setUserPreferenceLocalStorage(user.userPreference, auth);
  }

  async function loadUserPreference() {
    await doUserPreference()
      .then((res) => {
        setCountryID(user?.userPreference?.Country.CountryID);
      })
      .catch((err) => { });
  }

  const shouldSave = !isInitialized;
  let selectTypeGrid = isInitialized ? getTypeGrid(DivChart, DivMinute, shouldSave) : 2;

  //DivChart= 0-Chart | 1-MedComp | 2-Empty
  //DivMinute= 0-Minute | 1-Media | 2-Analitc
  //selectTypeGrid= 0:chart | 1:minute | 2:both | 3-none
  
  return (
    <PageRender
      setChangePageToChangePassword={setChangePageToChangePassword}
      DivMinute={DivMinute}
      countryID={countryID}
      user={user}
      renderDivMedComp={renderDivMedComp}
      DivChart={DivChart}
      renderDivMinuteChart={renderDivMinuteChart}
      selectTypeGrid={selectTypeGrid}
      SelectGrid={SelectGrid}
      renderDivTelaMedia={renderDivTelaMedia}
      renderDivAnalytic={renderDivAnalytic}
      getClassSelecGrid={getClassSelecGrid}
      sidebar={sidebar}
      controlNavBar={controlNavBar}
      changeSelectDiv={changeSelectDiv}
      getClassSelecGraphButton={getClassSelecGraphButton}
      t={t}
      loaded={user.loaded ?? false}
    />
  );

  function controlNavBar(component: string) {
    controlNavBarAux(component, sidebar, setSidebar, blurPanel);
  }
  function SelectGrid() {
    SelectGridAux(setSidebar);
  }
  function changeSelectDiv(typeSelec, valSelect) {
    changeSelectDivAux(typeSelec, valSelect, setDivChart, setDivMinute, DivMinute);
    controlNavBar("");
  }
}

export default Home;